import fetchData from 'src/utils/fetchData';

export const getOrganizationUsersAPI = async (organizationUeid: string) => {
  return fetchData(`/ui/front-api/private/organizations/${organizationUeid}/users`);
};

export const postInviteUserToOrganizationAPI = async (organizationUeid: string, data: any) => {
  return fetchData(`/ui/front-api/private/organizations/${organizationUeid}/users/invite-user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

export const postAcceptInvitationToOrganizationAPI = async (
  organizationUeid: string,
  invitationId: string
) => {
  return fetchData(
    `/ui/front-api/private/organizations/${organizationUeid}/users/accept-invitation`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: invitationId,
    }
  );
};

export const postLeaveOrganizationAPI = async (organizationUeid: string) => {
  return fetchData(`/ui/front-api/private/organizations/${organizationUeid}/users/current/leave`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteUserFromOrganizationAPI = async (organizationUeid: string, userUeid: string) => {
  return fetchData(`/ui/front-api/private/organizations/${organizationUeid}/users/${userUeid}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
